module.exports = __webpack_public_path__ + "static/testimonialGlobe-a51ec535ef72cdef9302322ae8286db2.png";